import { useTranslation } from 'react-i18next';
import styles from "./ConfirmModal.module.css";

const ConfirmModal = ({ onConfirm, onCancel, title, message }) => {
  const { t } = useTranslation(); // hook para traduzir

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h3>{title}</h3>
        <p>{message}</p>
        <div className={styles.actions}>
          <button className={styles.confirm} onClick={onConfirm}>{t('Confirm')}</button>
          <button className={styles.cancel} onClick={onCancel}>{t('Cancel')}</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;